import type { MapPlacement } from '../api'
import { CONE, CONE_REACH, DEFAULT_FOV, coneReach, positionOf, wedgePath } from '../siteMap'

/**
 * Which way a placed camera faces, how wide it sees and how far; nothing when
 * it has no direction. planWidth is the plan as drawn, in pixels.
 */
export function SiteMapCone({ placement: p, tone, planWidth }: { placement: MapPlacement; tone: 'highlight' | 'muted'; planWidth: number }) {
  if (p.direction === null) return null
  const d = wedgePath(p.direction, p.fov ?? DEFAULT_FOV)
  const size = coneReach(p, planWidth, CONE_REACH) * 2
  // Strokes keep their width in screen pixels however long the cone is.
  const stroke = { vectorEffect: 'non-scaling-stroke' as const, strokeLinejoin: 'round' as const }
  return (
    <svg
      aria-hidden
      data-cone={p.camera}
      viewBox="-1 -1 2 2"
      style={{ ...positionOf(p), width: `${size}px`, height: `${size}px` }}
      className="absolute -translate-x-1/2 -translate-y-1/2 pointer-events-none overflow-visible"
    >
      <path d={d} fill="none" stroke={CONE.halo} strokeWidth={4} {...stroke} />
      <path d={d} fill={tone === 'highlight' ? CONE.watched : CONE.other} />
      <path d={d} fill="none" stroke={CONE.edge} strokeWidth={1.5} {...stroke} />
    </svg>
  )
}
